import { Platform } from "quasar";

import { loadOrganisationToken } from "shared/helpers/authorization";
import { migrateStorage } from "shared/services/localForageInstance";
import StorageService from "shared/services/StorageService";
import { useUserStore } from "shared/stores/user";

export default async () => {
  if (Platform.is.capacitor) await migrateStorage();

  await loadOrganisationToken();

  const [token, identityProvider, accountManager] = await Promise.all([
    StorageService.get("token"),
    StorageService.get("identityProvider"),
    StorageService.get("accountManager", sessionStorage),
  ]);

  const isAdminUser = Boolean(
    accountManager && Object.keys(JSON.parse(accountManager)).length
  );

  await useUserStore().$patch({
    token,
    accountManager,
    identityProvider: identityProvider || "streem",
    isLoggedIn: Boolean(token),
    isAdminUser,
  });

  StorageService.expireKeys();

  return Promise.resolve();
};
